import React from "react";
import 'react-tippy/dist/tippy.css';
import { withTooltip } from 'react-tippy';
import TooltipIcon from "./TooltipIcon";

const Tooltip = ({
    text,
    placement='top',
    iconName='ExclamationCircleIcon',
    iconType='default',
    className='w-5 h-5',
    options={},
    ...rest
}) => {

  const component = () => (
    <TooltipIcon
      iconName={iconName}
      className={className}
      styleType={iconType}
      {...rest}
    />
  );

  return withTooltip(
    component,
    {
      title: text,
      position: placement,
      animation: 'fade',
      arrow: true,
      hideOnClick: true,
      ...options
    }
  )();
};

export default Tooltip;
